import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./routes/authentication/ProtectedRoute";
import LoginPage from "./pages/authentication/LoginPage";
import LandingPage from "./pages/LandingPage";
import DashboardRoutes from "./routes/DashboardRoutes";
import GlobalLayout from "./layouts/GlobalLayout";
import ErrorPage from "./pages/ErrorPage";
import RegisterPage from "./pages/authentication/RegisterPage";
import RegisterSelectionPage from "./pages/authentication/RegisterSelectionPage";
import "./assets/stylesheets/App.scss";
import ResetPassword from "./pages/authentication/ResetPassword";
import AuthenticationLayout from "./layouts/AuthenticationLayout";
import Icons from "./pages/Icons";
import { useStoreDispatch, useStoreSelector } from "./utils/hooks/hooks";
import {
  setModal,
  setPreventClose
} from "./utils/store/reducer/slices/modalReducer";
import { useEffect, useRef } from "react";
// PublicProgramPage import removed — /program/:id route deprecated (redirects to /login)
import InvitedUserRegistrationForm from "./components/authentication/InvitedUserRegistrationForm";
import AnnouncementPopup from './components/common/AnnouncementPopup';
import OnboardingDocumentation from "./pages/dashboard/OnboardingDocumentation";
import IntakeFormPage from "./pages/intake/IntakeFormPage";
import SSOCallback from "./pages/SSOCallback";




/**
 * The parent of all app components and
 * contains the root routes
 */
const App = () => {
  const dispatch = useStoreDispatch();
  const state = useStoreSelector(state => state.modal);
  const modalRef = useRef(state.preventClose);
  const selectedRef = useRef(state.selected);

  useEffect(() => {
    modalRef.current = state.preventClose;
    selectedRef.current = state.selected;
  }, [state]);

  return (
    <>
      <AnnouncementPopup />
      <main
        className="h-screen font-sans"
        onDragOver={e => e.preventDefault()}
        /**
         * Hide any active modals when anywhere else in the app is clicked
         */
        onClick={e => {
          setTimeout(() => {
            if (selectedRef.current !== undefined && !modalRef.current)
              dispatch(setModal({ selected: undefined }));
            dispatch(setPreventClose(false));
          }, 0); // <-- If there are issues with modals disappearing randomly then try increasing this value
          e.stopPropagation();
        }}
      >
        <Routes>
          <Route element={<GlobalLayout />}>
            {/* Send user to the dashboard if they're already logged in */}
            <Route index element={<LandingPage />} />

            {/* Authentication */}
            <Route element={<AuthenticationLayout />}>
              <Route path="login" element={<LoginPage />} />
              <Route path="sso/callback" element={<SSOCallback />} />
              <Route path="register" element={<RegisterSelectionPage />} />
              <Route path="/register/invited/:token" element={<InvitedUserRegistrationForm />} />
              <Route path="register/:userType" element={<RegisterPage />} />
              <Route path="reset-password" element={<ResetPassword />} />
            </Route>

            {/* Dashboard (requires login) */}
            <Route element={<ProtectedRoute />}>
              <Route path="dashboard/*" element={<DashboardRoutes />} />
            </Route>



            {/* Icon Collection for Development */}
            <Route path="/icons" element={<Icons />} />

            {/* /program/:id — deprecated: CTB no longer hosts public programs; redirect to login */}
            <Route path="program/:id" element={<Navigate to="/login" replace />} />
            <Route path="intake/:token" element={<IntakeFormPage />} />
            <Route path="intake/template/:publicToken" element={<IntakeFormPage />} />

            {/* Catch all Route */}
            <Route path="/*" element={<ErrorPage />} />
          </Route>
        </Routes>
      </main>
    </>
  );
};

export default App;
